export default "__VITE_ASSET__7KFnVELv__"